<template>
  <div class="step-success ChangeSuccess">
    <div class="ChangeSuccessOpt">
      <p class="messageBox">
        <img :src="require('@/assets/newImg/omplete.svg')" alt="" />
        <span v-if="queryType === 'password'">{{
          $fanyi("登录密码更改成功")
        }}</span>
        <span v-else-if="queryType === 'email'">{{
          $fanyi("邮箱更改成功")
        }}</span>
        <span v-else-if="queryType === 'mobile'">{{
          $fanyi("手机号更改成功")
        }}</span>
      </p>
      <el-button
        class="uiBtn nextBtn"
        @click="$fun.routerToPage('/user/index')"
      >
        {{ $fanyi("返回主页") }}
      </el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepSuccess",
  computed: {
    queryType() {
      return this.$route.query.type;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/css/mixin.scss";

.step-success.ChangeSuccess {
  .ChangeSuccessOpt {
    .messageBox {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 80px;
      margin-bottom: 40px;
      img {
        width: 40px;
        height: 40px;
        margin-bottom: 24px;
      }
      span {
        font-size: 16px;
        font-weight: normal;
        color: #000000;
        line-height: 20px;
      }
    }
  }
}
</style>
